"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpViewFields = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const StaticFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/StaticFieldType/StaticFieldType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_pages_1 = __importDefault(require("@opsbase/lib-pages"));
const ViewFieldKey_1 = __importDefault(require("../ViewFieldKey"));
exports.OpViewFields = {
    [ViewFieldKey_1.default.OP_SCORE]: {
        key: ViewFieldKey_1.default.OP_SCORE,
        label: () => lib_i18n_1.default.t('score'),
        description: () => lib_i18n_1.default.t('score-description'),
        sortable: true,
        fieldType: BasicFieldType_1.default.OP_SCORE,
        width: 150,
        gqlFields: 'form, isScoreEnabled, isScorePublic, grade, gradingMethod',
    },
    [ViewFieldKey_1.default.OP_GRADE]: {
        key: ViewFieldKey_1.default.OP_GRADE,
        label: () => lib_i18n_1.default.t('grade'),
        description: () => lib_i18n_1.default.t('grade-description'),
        sortable: true,
        fieldType: StaticFieldType_1.default.OP_GRADE,
        width: 150,
        gqlFields: 'grade, isScoreEnabled, isScorePublic, grade, gradingMethod',
    },
    [ViewFieldKey_1.default.OP_PASSSTATUS]: {
        key: ViewFieldKey_1.default.OP_PASSSTATUS,
        label: () => lib_i18n_1.default.t('pass-fail'),
        description: () => lib_i18n_1.default.t('pass-fail-description'),
        sortable: true,
        fieldType: StaticFieldType_1.default.OP_PASSSTATUS,
        propertyName: 'passFailStatus',
        width: 150,
        gqlFields: 'passFailStatus, gradingMethod',
    },
    [ViewFieldKey_1.default.OP_ISADHOC]: {
        key: ViewFieldKey_1.default.OP_ISADHOC,
        label: () => lib_i18n_1.default.t('is-adhoc'),
        description: () => lib_i18n_1.default.t('is-adhoc-description'),
        sortable: true,
        fieldType: BasicFieldType_1.default.OP_ISADHOC,
        propertyName: 'isAdhoc',
        width: 100,
        gqlFields: 'isAdhoc',
    },
    [ViewFieldKey_1.default.OP_ISSUES]: {
        key: ViewFieldKey_1.default.OP_ISSUES,
        label: () => lib_i18n_1.default.t('op-issues'),
        description: () => lib_i18n_1.default.t('op-issues-description'),
        sortable: false,
        fieldType: BasicFieldType_1.default.OP_ISSUE_COUNTS,
        propertyName: 'opScheduleId',
        width: 100,
        gqlFields: 'issues { id, status }',
    },
    [ViewFieldKey_1.default.OP_STARTFROM]: {
        key: ViewFieldKey_1.default.OP_STARTFROM,
        label: () => lib_i18n_1.default.t('start-from'),
        description: () => lib_i18n_1.default.t('start-from-description'),
        sortable: true,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'startFrom',
        width: 150,
        gqlFields: 'place { id, timezone } ,startFrom',
    },
    [ViewFieldKey_1.default.OP_STATUS]: {
        key: ViewFieldKey_1.default.OP_STATUS,
        label: () => lib_i18n_1.default.t('op-status'),
        description: () => lib_i18n_1.default.t('op-status-description'),
        sortable: true,
        fieldType: StaticFieldType_1.default.OP_STATUS,
        width: 120,
        gqlFields: 'awaitingApproval, startFrom, completeBy, actualStart, missedDeadlineDate, closedDate, actualComplete',
    },
    [ViewFieldKey_1.default.OP_ACTUALSTART]: {
        key: ViewFieldKey_1.default.OP_ACTUALSTART,
        label: () => lib_i18n_1.default.t('actual-start'),
        description: () => lib_i18n_1.default.t('actual-start-description'),
        sortable: true,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'actualStart',
        width: 150,
        gqlFields: 'place { id, timezone } , actualStart',
    },
    [ViewFieldKey_1.default.OP_ACTUALCOMPLETE]: {
        key: ViewFieldKey_1.default.OP_ACTUALCOMPLETE,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'actualComplete',
        label: () => lib_i18n_1.default.t('actual-complete'),
        description: () => lib_i18n_1.default.t('actual-complete-description'),
        sortable: true,
        width: 150,
        gqlFields: 'place { id, timezone } , actualComplete',
    },
    [ViewFieldKey_1.default.OP_COMPLETEBY]: {
        key: ViewFieldKey_1.default.OP_COMPLETEBY,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'completeBy',
        label: () => lib_i18n_1.default.t('complete-by'),
        description: () => lib_i18n_1.default.t('complete-by-description'),
        sortable: true,
        width: 150,
        gqlFields: 'place { id, timezone },completeBy',
    },
    [ViewFieldKey_1.default.OP_SUBMITTEDBY]: {
        key: ViewFieldKey_1.default.OP_SUBMITTEDBY,
        fieldType: BasicFieldType_1.default.RELATED_USER,
        propertyName: 'submittedBy',
        label: () => lib_i18n_1.default.t('submitted-by'),
        description: () => lib_i18n_1.default.t('submitted-by-description'),
        sortable: true,
        linkPage: lib_pages_1.default.STAFF_EDIT,
        width: 180,
        gqlFields: 'submittedBy { id, title, profileImageUrl }',
    }
};
exports.default = exports.OpViewFields;
